<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
    <path fill="#000" fill-rule="evenodd" d="M1.707 2.75c0-.966.784-1.75 1.75-1.75H9.52a.75.75 0 0 1 0 1.5H3.457a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25H9.52a.75.75 0 0 1 0 1.5H3.457a1.75 1.75 0 0 1-1.75-1.75V2.75ZM6.231 9a.75.75 0 0 1 .75-.75h8.753l-2.72-2.72a.75.75 0 1 1 1.061-1.06l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06-1.06l2.72-2.72H6.98A.75.75 0 0 1 6.23 9Z" clip-rule="evenodd"></path>
  </svg>
</template>
